import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import type { CallbackErrorAwareAuthService } from './callback-error-aware-auth.service';

/**
 * Bug 37976: the panel shown over the app when Auth0 refused the login (`?error=access_denied`). It says why and offers
 * Try again (the Auth0 login screen) or Sign out (ends the refused session). The app makes no auth attempt meanwhile.
 */
@Component({
  selector: 'ups-auth0-callback-error',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './auth0-callback-error.component.html',
  styleUrl: './auth0-callback-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Auth0CallbackErrorComponent {
  readonly auth = input.required<CallbackErrorAwareAuthService>();

  readonly description = computed(
    () => this.auth().callbackError()?.description ?? ''
  );
  readonly leaving = signal(false);

  tryAgain(): void {
    this.leaving.set(true);
    this.auth().retry().subscribe();
  }

  signOut(): void {
    this.leaving.set(true);
    this.auth().signOut();
  }
}
